import type { DualCurrencyData } from '@travelity/api/generated';

export const getMinPriceFromDualCurrency = (
    price?: DualCurrencyData['original']
): number => {
    if (!price) return 0;

    if (typeof price === 'number') return price;

    if ('unit_amount' in price) {
        // FlatPricingData
        const base = price.base_amount ?? 0;
        return base + price.unit_amount;
    }

    if ('type' in price && price.type === 'per_ageband') {
        // AgebandPricingData
        const base = price.base_amount ?? 0;
        const adult = price.adults ?? 0;
        return base + adult;
    }

    return 0;
};
